/**
 * The booking store's refresh from the server when the tab regains focus
 * (bookingFlowStore), with a way for an app to turn it off: membership-first,
 * whose entry, plan, payment and account screens are not the store's steps.
 * There the refresh wrote the store's step into the URL over the screen on
 * show, and a failed fetch reset the flow.
 */
let enabled = true;

export const disableRefreshOnTabFocus = () => {
  enabled = false;
};

/** Runs `refresh` each time the tab regains focus, while it is on. */
export const refreshOnTabFocus = (refresh: () => void) => {
  if (typeof window === "undefined") return;
  window.addEventListener("focus", () => {
    if (enabled) refresh();
  });
};
